import { Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import StyledWrapper from './style';
import CustomModal from '../Modal/Modal';

const CopyFormModal = ({ isOpen, handleClose, formType, templateLink, templateLinkText }) => (
	<CustomModal
		width={'auto'}
		isOpen={isOpen}
		setClose={handleClose}
		center={true}
		overflow={'hidden'}
	>
		<StyledWrapper.ModalContainer>
			<StyledWrapper.ModalTitle>
				<ErrorOutlineIcon color="primary" />
				The new template was successfully created!
			</StyledWrapper.ModalTitle>
			<StyledWrapper.ModalContentContainer>
				<StyledWrapper.ModalContent>
					The new template matches the original form's name and structure.
				</StyledWrapper.ModalContent>
				<StyledWrapper.ModalContent>
					You can rename it and edit its element and structure as needed.
				</StyledWrapper.ModalContent>
				<StyledWrapper.ModalContent>
					{`Can be found in the ${formType} Templates section: `}
					<StyledWrapper.ModalLink to={templateLink}>{templateLinkText}</StyledWrapper.ModalLink>.
				</StyledWrapper.ModalContent>
			</StyledWrapper.ModalContentContainer>
			<Button variant="outlined" size="small" sx={{ minWidth: '38px' }} onClick={handleClose}>
				OK
			</Button>
		</StyledWrapper.ModalContainer>
	</CustomModal>
);

export default CopyFormModal;
